"use client"
import CommonTitle from "@/ui/common/bit/CommonTitle"
import styled from "@emotion/styled"
import { mediaQueries, sizes } from "ui"
import BlockWrapper, { BlockWrapperProps } from "../../common/BlockWrapper"

export const StyledContainer = styled.div`
  display: grid;
  ${mediaQueries.mobile} {
    align-items: center;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    gap: ${sizes.baseTriple};
  }
  ${mediaQueries.tablet} {
    align-items: center;
    gap: ${sizes.baseTriple};
  }

  ${mediaQueries.desktop} {
    grid-template-columns: 1fr 1fr;
    text-align: start;
    gap: ${sizes.baseSix};
  }
  ${mediaQueries.desktopM} {
    text-align: start;
    gap: ${sizes.baseSix};
  }
`
export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  ${mediaQueries.desktopM} {
  }
`
export const StyledBlockWrapperForm = styled(BlockWrapper)<BlockWrapperProps>`
  ${mediaQueries.desktopM} {
    padding-left: 100px;
    padding-right: 100px;
  }
`

export const StyledCommonTitle = styled(CommonTitle)`
  ${mediaQueries.desktopM} {
    align-items: flex-start;
    gap: 24px;
    h2 {
      text-align: start;
    }
  }
`
